import { render, staticRenderFns } from "./JcomPlanList.vue?vue&type=template&id=489210ce"
import script from "./JcomPlanList.vue?vue&type=script&lang=js"
export * from "./JcomPlanList.vue?vue&type=script&lang=js"
import style0 from "./JcomPlanList.vue?vue&type=style&index=0&id=489210ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports